<template>
  <div class="app-navbar-actions">
    <div class="nxl-header">
      <div class="header-wrapper">
        <div class="header-right ms-auto">
          <div class="d-flex align-items-center">
            <!--国际化-->
            <div class="dropdown nxl-h-item nxl-header-language d-none d-sm-flex">
              <a
                href="javascript:void(0);"
                class="nxl-head-link me-0 nxl-language-link"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
              >
                <img :src="locale_map[userStorage.locale]['picture']" alt="" class="img-fluid wd-20" />
              </a>
              <div class="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-language-dropdown">
                <div class="language-items-wrapper">
                  <div class="row px-4 pt-3">
                    <div v-for="(item, key) in locale_map" class="col-6 language_select">
                      <a href="javascript:void(0);" class="d-flex align-items-center gap-2" @click="change_locale(key)">
                        <div class="avatar-image avatar-sm">
                          <img :src="item['picture']" alt="" class="img-fluid" />
                        </div>
                        <span>{{ t(item['languge']) }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ScreenFull />
            <div class="nxl-h-item dark-light-theme">
              <a v-if="theme == 'light'" class="nxl-head-link me-0 dark-button" @click="theme = 'dark'">
                <i class="feather-moon"></i>
              </a>
              <a v-if="theme == 'dark'" class="nxl-head-link me-0 light-button" @click="theme = 'light'">
                <i class="feather-sun"></i>
              </a>
            </div>

            <!-- 消息通知 -->
            <!-- <div class="dropdown nxl-h-item">
              <a class="nxl-head-link me-3" data-bs-toggle="dropdown" href="#" role="button" data-bs-auto-close="outside" aria-expanded="true">
                <i class="feather-bell"></i>
                <span class="badge bg-danger nxl-h-badge" style="margin-top:2px;">3</span>
              </a>
              <div class="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-notifications-menu" data-popper-placement="bottom-end" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(-273px, 64px);">
                <div class="d-flex justify-content-between align-items-center notifications-head">
                  <h6 class="fw-bold text-dark mb-0">消息通知</h6>
                  <a href="javascript:void(0);" class="fs-11 text-success text-end ms-auto" data-bs-toggle="tooltip" title="" data-bs-original-title="全部标记为已读">
                    <i class="feather-check"></i>
                    <span>全部标记为已读</span>
                  </a>
                </div>
                <div class="notifications-item">
                  <img src="/imgs/2.png" alt="" class="rounded me-3 border">
                  <div class="notifications-desc">
                    <a href="javascript:void(0);" class="font-body text-truncate-2-line">
                      <span class="fw-semibold text-dark">Malanie Hanvey</span> We should talk about that at lunch!</a>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="notifications-date text-muted border-bottom border-bottom-dashed">2 minutes ago</div>
                      <div class="d-flex align-items-center float-end gap-2">
                        <a href="javascript:void(0);" class="d-block wd-8 ht-8 rounded-circle bg-gray-300" data-bs-toggle="tooltip" title="" data-bs-original-title="Make as Read" aria-label="Make as Read"></a>
                        <a href="javascript:void(0);" class="text-danger" data-bs-toggle="tooltip" title="" data-bs-original-title="Remove">
                          <i class="feather-x fs-12"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="notifications-item">
                  <img src="/imgs/3.png" alt="" class="rounded me-3 border">
                  <div class="notifications-desc">
                    <a href="javascript:void(0);" class="font-body text-truncate-2-line">
                      <span class="fw-semibold text-dark">Valentine Maton</span> You can download the latest invoices now.</a>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="notifications-date text-muted border-bottom border-bottom-dashed">36 minutes ago</div>
                      <div class="d-flex align-items-center float-end gap-2">
                        <a href="javascript:void(0);" class="d-block wd-8 ht-8 rounded-circle bg-gray-300" data-bs-toggle="tooltip" title="" data-bs-original-title="Make as Read" aria-label="Make as Read"></a>
                        <a href="javascript:void(0);" class="text-danger" data-bs-toggle="tooltip" title="" data-bs-original-title="Remove">
                          <i class="feather-x fs-12"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="notifications-item">
                  <img src="/imgs/4.png" alt="" class="rounded me-3 border">
                  <div class="notifications-desc">
                    <a href="javascript:void(0);" class="font-body text-truncate-2-line">
                      <span class="fw-semibold text-dark">Archie Cantones</span> Don't forget to pickup Jeremy after school!</a>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="notifications-date text-muted border-bottom border-bottom-dashed">53 minutes ago</div>
                      <div class="d-flex align-items-center float-end gap-2">
                        <a href="javascript:void(0);" class="d-block wd-8 ht-8 rounded-circle bg-gray-300" data-bs-toggle="tooltip" title="" data-bs-original-title="Make as Read" aria-label="Make as Read"></a>
                        <a href="javascript:void(0);" class="text-danger" data-bs-toggle="tooltip" title="" data-bs-original-title="Remove">
                          <i class="feather-x fs-12"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="dropdown nxl-h-item nav-avatar">
              <a
                href="javascript:void(0);"
                data-bs-toggle="dropdown"
                role="button"
                data-bs-auto-close="outside"
                class=""
              >
                <i class="fas fa-user-circle display-6"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">
                <div class="dropdown-header">
                  <div class="d-flex align-items-center">
                    <div>
                      <h6 class="text-dark mb-0">
                        {{ userStorage.userName }}
                        <span class="badge bg-soft-success text-success ms-1">
                          {{ userStorage?.role?.name || $t('user.ordinaryUser') }}
                        </span>
                      </h6>
                      <span class="fs-12 fw-medium text-muted">{{ userStorage.email }}</span>
                      <h5 style="max-width: 245px; white-space: wrap">{{ $t('user.subscriptionTime') }}</h5>
                    </div>
                  </div>
                </div>
                <a class="dropdown-item" @click="passwd_modal = true">
                  <i class="feather-key"></i>
                  <span>{{ $t('user.pwdChange') }}</span>
                </a>
                <!-- <a class="dropdown-item" @click="show_meal">
                  <i class="feather-dollar-sign"></i>
                  <span>{{ $t('user.billing') }}</span>
                </a> -->
                <div class="dropdown-divider"></div>
                <a href="javascript:void(0);" class="dropdown-item" @click="click_logout">
                  <i class="feather-log-out"></i>
                  <span>{{ $t('user.logout') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <BModal v-model="passwd_modal" size="xl" :title="t('user.pwdChange')" footer-class="d-none">
      <div class="row">
        <div class="col-lg-12">
          <div class="card-body pass-info">
            <div class="mb-4 d-flex align-items-center justify-content-between">
              <h5 class="fw-bold mb-0 me-4">
                <span class="fs-12 fw-normal text-muted text-truncate-1-line">{{ t('user.pwdChangeInfo') }} </span>
              </h5>
            </div>
            <VaForm ref="rest_form" class="w-100 mt-4 pt-2">
              <VaValue v-slot="isPasswordVisible" :default-value="false">
                <div class="row mb-4 align-items-center">
                  <div class="col-lg-4 d-flex align-items-center h-100">
                    <label for="Input" class="fw-semibold">{{ $t('auth.password') }}:</label>
                  </div>
                  <div class="col-lg-8 d-flex align-items-center h-100">
                    <div class="input-group">
                      <div class="input-group-text"><i class="feather-key"></i></div>
                      <VaInput
                        ref="password1"
                        v-model="reset_form.password"
                        :rules="passwordRules"
                        :type="isPasswordVisible.value ? 'text' : 'password'"
                        class="form-control p-0 border-0"
                        :placeholder="$t('auth.input_new_password')"
                        @clickAppendInner.stop="isPasswordVisible.value = !isPasswordVisible.value"
                      >
                        <template #appendInner>
                          <VaIcon
                            :name="isPasswordVisible.value ? 'mso-visibility_off' : 'mso-visibility'"
                            class="cursor-pointer"
                            color="secondary"
                          />
                        </template>
                      </VaInput>
                    </div>
                  </div>
                </div>

                <div class="row mb-4 align-items-center">
                  <div class="col-lg-4 d-flex align-items-center h-100">
                    <label for="Input" class="fw-semibold">{{ t('password.again') }}: </label>
                  </div>
                  <div class="col-lg-8 d-flex align-items-center h-100">
                    <div class="input-group">
                      <div class="input-group-text"><i class="feather-key"></i></div>
                      <VaInput
                        ref="password2"
                        v-model="reset_form.repeatPassword"
                        :rules="[
                          (v) => !!v || $t('auth.passwordeRequired'),
                          (v) => v === reset_form.password || $t('auth.password_no_match'),
                        ]"
                        :type="isPasswordVisible.value ? 'text' : 'password'"
                        class="form-control p-0 border-0"
                        x
                        :placeholder="$t('auth.repassword_new_placeholder')"
                        @clickAppendInner.stop="isPasswordVisible.value = !isPasswordVisible.value"
                      >
                        <template #appendInner>
                          <VaIcon
                            :name="isPasswordVisible.value ? 'mso-visibility_off' : 'mso-visibility'"
                            class="cursor-pointer"
                            color="secondary"
                          />
                        </template>
                      </VaInput>
                    </div>
                  </div>
                </div>
              </VaValue>
            </VaForm>
            <div class="pass-hint">
              <p class="fw-bold">{{ t('password.ask.title') }}:</p>
              <ul class="fs-12 ps-1 ms-2 text-muted pass-ask-info">
                <li class="mb-1">{{ t('password.ask.length') }}</li>
                <li class="mb-1">{{ t('password.ask.number_letter') }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="button-items" style="display: flex; gap: 10px">
          <button type="button" class="btn btn-outline-primary" @click="reset_passwd">
            <i class="fas fa-save"></i>&nbsp;{{ t('buttons.ok') }}
          </button>
          <button type="button" class="btn btn-outline-secondary" @click="passwd_modal = false">
            <i class="fas fa-window-close"></i>&nbsp;{{ t('buttons.cancel') }}
          </button>
        </div>
      </div>
    </BModal>

    <BModal v-model="meal_modal" footer-class="d-none" size="xl" :title="t('subscription.title')">
      <div class="row">
        <div class="col-lg-12">
          <div class="card-body choose-plan">
            <div class="mb-4 d-flex align-items-center justify-content-between">
              <h5 class="fw-bold mb-0" style="font-size: 1rem">{{ t('subscription.validity') }}:</h5>
              <a href="javascript:void(0);" class="btn btn-sm btn-light-brand">{{ t('subscription.infinite') }}</a>
            </div>
            <div
              class="p-4 mb-4 d-xxl-flex d-xl-block d-md-flex align-items-center justify-content-between gap-4 border border-dashed border-gray-5 rounded-1"
            >
              <div>
                <div class="fs-14 fw-bold text-dark mb-1">
                  {{ t('subscription.version.title') }}
                  <a href="javascript:void(0);" class="badge bg-primary text-white ms-2">{{
                    meal_map[meal_data['ss_type']]
                  }}</a>
                </div>
                <div class="fs-12 text-muted">{{ t('subscription.most') }}</div>
              </div>
              <div class="my-3 my-xxl-0 my-md-3 my-md-0">
                <div class="fs-20 text-dark">
                  <span class="fw-bold">{{ t('subscription.price') }}</span> /
                  <em class="fs-11 fw-medium">{{ t('subscription.quarter') }}</em>
                </div>
                <div class="fs-12 text-muted mt-1">{{ t('subscription.expiration') }}{{ meal_data['end_date'] }}</div>
              </div>
            </div>
            <div class="row" style="display: flex">
              <div class="col-md-4">
                <a
                  href="javascript:void(0);"
                  class="p-4 mb-4 d-block bg-soft-200 border border-dashed border-gray-5 rounded-1 position-relative"
                  style="height: 168px"
                >
                  <h6 class="fs-13 fw-bold">{{ t('subscription.basic.title') }}</h6>
                  <p class="fs-12 fw-normal text-muted">{{ t('subscription.basic.member') }}</p>
                  <p class="fs-12 fw-normal text-muted text-truncate-2-line">
                    {{ t('subscription.basic.info') }}
                  </p>
                  <div class="mt-4">
                    <span class="fs-16 fw-bold text-dark"> {{ t('subscription.basic.price') }}</span> /
                    <em class="fs-11 fw-medium">{{ t('subscription.quarter') }}</em>
                  </div>
                  <div v-if="meal_data.ss_type == 'BASIC'" class="position-absolute top-0 start-50 translate-middle">
                    <i class="feather-check fs-12 bg-primary text-white p-1 rounded-circle"></i>
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  href="javascript:void(0);"
                  class="p-4 mb-4 d-block bg-soft-100 border border-dashed border-gray-5 rounded-1"
                  style="height: 168px"
                >
                  <h6 class="fs-13 fw-bold">{{ t('subscription.senior.title') }}</h6>
                  <p class="fs-12 fw-normal text-muted">{{ t('subscription.senior.member') }}</p>
                  <p class="fs-12 fw-normal text-muted text-truncate-2-line">{{ t('subscription.senior.info') }}</p>
                  <div class="mt-4">
                    <span class="fs-16 fw-bold text-dark">{{ t('subscription.senior.price') }}</span> /
                    <em class="fs-11 fw-medium">{{ t('subscription.quarter') }}</em>
                  </div>
                  <div v-if="meal_data.ss_type == 'PERMIUM'" class="position-absolute top-0 start-50 translate-middle">
                    <i class="feather-check fs-12 bg-primary text-white p-1 rounded-circle"></i>
                  </div>
                </a>
              </div>
              <div class="col-md-4">
                <a
                  href="javascript:void(0);"
                  class="p-4 mb-4 d-block bg-soft-100 border border-dashed border-gray-5 rounded-1"
                  style="height: 168px"
                >
                  <h6 class="fs-13 fw-bold">{{ t('subscription.custom.title') }}</h6>
                  <p class="fs-12 fw-normal text-muted">{{ t('subscription.custom.member') }}</p>
                  <p class="fs-12 fw-normal text-muted text-truncate-2-line">{{ t('subscription.custom.info') }}</p>
                  <div class="mt-4">
                    <span class="fs-16 fw-bold text-dark">{{ t('subscription.custom.price') }}</span>
                  </div>
                  <div v-if="meal_data.ss_type == 'CUSTOM'" class="position-absolute top-0 start-50 translate-middle">
                    <i class="feather-check fs-12 bg-primary text-white p-1 rounded-circle"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script lang="ts" setup>
import { change_password, logout } from '@/apis/auth'
import { subscribe_get } from '@/apis/common'
import { useForm } from 'vuestic-ui'
import { useUserStore } from 'obst/user-store'
import { useRouter } from 'vue-router'
import ScreenFull from '@/components/ScreenFull.vue'
const { replace } = useRouter()

const { validate } = useForm('rest_form')

defineProps({
  isMobile: { type: Boolean, default: false },
})

import { useI18n } from 'vue-i18n'
import { ref, reactive, onMounted, onBeforeMount } from 'vue'
const { t, locale } = useI18n()
import { computed } from 'vue'

import { useColors } from 'vuestic-ui'
import { toast_success, toast_warning } from '@/utils/obtoast'

const { applyPreset, currentPresetName } = useColors()

const theme = computed({
  get() {
    return currentPresetName.value
  },
  set(value) {
    const html = document.documentElement
    if (value == 'dark') {
      html.classList.add('app-skin-dark')
    } else {
      html.classList.remove('app-skin-dark')
    }
    applyPreset(value)
  },
})

// 用户信息
const userStorage = useUserStore()

onBeforeMount(() => {
  locale.value = userStorage.locale
})

onMounted(() => {
  // locale.value = userStorage.locale
})

// 语言
const locale_map = ref({
  cn: {
    picture: '/imgs/ch.svg',
    languge: 'language.simplified_chinese',
  },
  en: {
    picture: '/imgs/us.svg',
    languge: 'language.english',
  },
})
const change_locale = function (req) {
  if (req != userStorage.locale) {
    userStorage.locale = req
    locale.value = req
  }
}

// 修改密码
const passwordRules: ((v: string) => boolean | string)[] = [
  (v) => !!v || t('auth.passwordeRequired'),
  (v) => (v && v.length >= 8) || t('auth.passwordRule1'),
  (v) => (v && /[A-Za-z]/.test(v)) || t('auth.passwordRule2'),
  (v) => (v && /\d/.test(v)) || t('auth.passwordRule3'),
  (v) => (v && /[!@#$%^&*(),.?":{}|<>]/.test(v)) || t('auth.passwordRule4'),
]
const passwd_modal = ref(false)
const reset_form = reactive({
  password: '',
  repeatPassword: '',
})
const reset_passwd = function () {
  console.log(validate())
  if (validate()) {
    change_password(reset_form).then((res) => {
      const { data } = res
      toast_success(data['msg'])
      // 清楚token
      userStorage.tokenSetExpired()
      // 跳转链接
      replace('/auth/login')
    })
  }
}

// 退出登录
const click_logout = function () {
  logout().then((res) => {
    const { data } = res
    toast_success(data['msg'])
    // 清楚token
    userStorage.tokenSetExpired()
    // 跳转链接
    replace('/auth/login')
  })
}

// 套餐信息
const meal_map = computed(() => ({
  FREE: t('subscription.version.free'),
  BASIC: t('subscription.version.basic'),
  PERMIUM: t('subscription.version.permium'),
  CUSTOM: t('subscription.version.custom'),
}))
const meal_modal = ref(false)
const meal_data = ref({
  start_date: '',
  end_date: '',
  user: 10,
  ss_type: 'FREE',
})
const show_meal = function () {
  // 显示数据
  meal_modal.value = true
  // 获取数据
  subscribe_get().then((res) => {
    const { data } = res
    meal_data.value = data
  })
}
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;
  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}
.pass-ask-info {
  list-style-type: disc;
  margin-top: 16px;
  margin-bottom: 30px;
}
.modal-title {
  font-size: 1rem;
  font-weight: 700;
}
.modal-dialog {
  max-width: 1600px;
}
.modal-dialog.modal-sm {
  max-width: 800px;
}
.modal-footer {
  width: calc(100% + 50px);
  margin-left: -25px;
  padding-bottom: 0;
}

.nav-avatar {
  margin-left: 1em;
}
</style>
